import { IndexBar, List } from 'antd-mobile'
import styles from './index.scss'
import { IndexBarRef } from 'antd-mobile/es/components/index-bar'

interface IDpIndexProps {
  data?: any[]
  rowKey?: string
  style?: React.CSSProperties
  header?: () => void
  dataSource?: Record<string, any[]>
  renderList?: (list?: any[], value?: string) => void
  renderItem?: (list?: any[]) => void
}

const DpIndexBar = (props: Partial<IndexBarRef> & IDpIndexProps) => {
  return (
    <IndexBar className={styles['dp-index-bar']} style={props?.style}>
      {props?.header?.()}
      {Object.keys(props?.dataSource || {})?.map(group => {
        return (
          <IndexBar.Panel
            index={group}
            title={group}
            key={group}
          >
            {
              props?.renderList?.(props?.dataSource?.[group], group) || 
                <List>
                  {props?.dataSource?.[group].map((item) => props?.renderItem?.(item) || <List.Item key={item?.[props?.rowKey || 'code']}>{item?.name}</List.Item>)}
                </List>
            }
          </IndexBar.Panel>
        )
      })}
    </IndexBar>
  )
}

export default DpIndexBar
